import { ReactElement, useEffect, useRef, useState } from "react"
import { Viewer, Worker, LoadError, DocumentLoadEvent } from '@react-pdf-viewer/core';
import { toolbarPlugin } from '@react-pdf-viewer/toolbar';
import pdfjsWorker from 'pdfjs-dist/build/pdf.worker.entry'
import { defaultLayoutPlugin, ToolbarProps, ToolbarSlot } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/toolbar/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import { AmnProvider, useAmn } from "../contexts/AmnContext";
import QRCode from "react-qr-code";

const PdfReader = (props :  {file : string}) =>{
    const amn = useAmn();


    const closePdf = () =>{
        amn.setShowPDF({show : false, disposition: "full"});
    }

    const showQRCode = () =>{
        amn.setShowPDFQRCode(true);
        amn.setShowPDF({show : false, disposition: amn.showPDF.disposition});
    }

    const hideQRCode = () =>{
        amn.setShowPDFQRCode(false);
        amn.setShowPDF({show : true, disposition: amn.showPDF.disposition});
    }

      let renderToolbar = (Toolbar: (props: ToolbarProps) => ReactElement) => (
        <Toolbar>
            {(slots: ToolbarSlot) => {
                //console.log("renderToolbar");
                const {
                    CurrentPageInput,
                    Download,
                    EnterFullScreen,
                    GoToNextPage,
                    GoToPreviousPage,
                    NumberOfPages,
                    Print,
                    ShowSearchPopover,
                    Zoom,
                    ZoomIn,
                    ZoomOut,
                } = slots;
                //console.log("renderToolbar");
                //console.log(props.file);
                //console.log(slots)
                return (
                    <div className="pdfToolbarContainer">
                        <div className="pdfToolbarLeft">
                            <div style={{ padding: '0px 2px' }}>
                                <ShowSearchPopover />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <ZoomOut />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <Zoom />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <ZoomIn />
                            </div>
                        </div>

                        <div className="pdfToolbarRight">
                            <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                <GoToPreviousPage />
                            </div>
                            <div style={{ padding: '0px 2px', width: '4rem' }}>
                                <CurrentPageInput />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                / <NumberOfPages />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <GoToNextPage />
                            </div>
                        </div>

                        <div className="pdfToolbarMiddle">
                            <div style={{ padding: '0px 2px', marginLeft: 'auto' }}>
                                <EnterFullScreen />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <Download />
                            </div>
                            <div style={{ padding: '0px 2px' }}>
                                <Print />
                            </div>
                            <div>
                                <button className="rpv-core__minimal-button" onClick={()=>showQRCode()}>
                                    Afficher le QR Code
                                </button>
                            </div>
                            <div>
                                <button className="rpv-core__minimal-button" onClick={()=>closePdf()}>
                                    Fermer
                                </button>
                            </div>
                        </div>
                    </div>
                );
            }}
        </Toolbar>
                        
    );

    const renderError = (error: LoadError) => {
        let message = 'Une erreur est survenue lors du chargement du PDF';
        console.log("ERROR loading PDF", error);
        //Add button close
    
        return (
        <>
            <button className="rpv-core__minimal-button closeErrorButton" onClick={()=>closePdf()}>
                Fermer
            </button>
            <div
                style={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                }}
            >
                <div
                    style={{
                        backgroundColor: '#e53e3e',
                        borderRadius: '0.25rem',
                        color: '#fff',
                        padding: '0.5rem',
                    }}
                >
                    {message}
                </div>
            </div>
        </>
        );
    };

    const handleDocumentLoad = (e: DocumentLoadEvent) => {
        const { activateTab } = defaultLayoutPluginInstance;
        //console.log(e);
        // Activate the bookmark tab
        //activateTab(1);
    };

    let defaultLayoutPluginInstance = defaultLayoutPlugin({
        renderToolbar,
        sidebarTabs: (defaultTabs) => [
            defaultTabs[0], // Bookmarks tab
            defaultTabs[1], // Thumbnails tab
        ],
    });


      useEffect(()=>{

        if(amn.showPDFButtons){
            let btn_container = document.createElement("div");
            btn_container.className = "rounded bg-black bg-opacity-card text-white p-4 large:py-8 flex flex-wrap justify-around gap-3 overflow-y-auto w-full max-h-full scrollbar-thin";
            btn_container.id = "Button_Container"
    
    
            let btn_pdf_show = document.createElement("button");
            btn_pdf_show.innerHTML = "Ouvrir le PDF";
            btn_pdf_show.id = "Button_PDFShow"
            btn_pdf_show.className = "bg-primary flex justify-self-center self-center text-black rounded p-3 m-auto mt-2 mb-2";
            btn_pdf_show.onclick = () =>{
                amn.setShowPDF({show : true, disposition: "full"});
                var nextBtn = document.getElementById("Button_PDFNext");
                if(nextBtn){
                    nextBtn.style.display = "initial";
                }
    
            }
              
    
            let btn_pdf_next = document.createElement("button");
            btn_pdf_next.innerHTML = "Continuer";
            btn_pdf_next.id = "Button_PDFNext"
            btn_pdf_next.className = "bg-primary flex justify-self-center self-center text-black rounded p-3 m-auto mt-2 mb-2";
            btn_pdf_next.style.display = "none";
            btn_pdf_next.onclick = () =>{
                let CHUEvent = new CustomEvent('CHUEvent', {
                    detail : {
                        name : "ClosePDF"
                    }
                });
                document.dispatchEvent(CHUEvent);
                document.getElementById("Button_Container")?.remove();
            }
    
    
            btn_container.append(btn_pdf_show);
            btn_container.append(btn_pdf_next);
            document.getElementById("retorik-botResponse")?.append(btn_container);
        }

      }, [amn.showPDFButtons])


      return (
          <>
            <div className={`pdfViewerOverlay ${amn.showPDF.disposition}`} style={{display:amn.showPDF.show ? 'inherit' : 'none'}}>
                <div className="pdfViewer" >
                    {/* <div
                        style={{
                            alignItems: 'center',
                            backgroundColor: '#eeeeee',
                            borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
                            display: 'flex',
                            padding: '4px',
                        }}
                    >
                        <Toolbar />
                    </div> */}
                    <div
                        style={{
                            flex: 1,
                            overflow: 'hidden',
                        }}
                    >
                        <Worker workerUrl={`https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js`}/>
                        <Viewer  fileUrl={props.file} plugins={[defaultLayoutPluginInstance]} renderError={renderError} onDocumentLoad={handleDocumentLoad}/>   
                       
                        
                    </div>
                </div>
            </div>
                {
                    amn.showPDFQRCode && amn.pdfToDisplay &&
                        <div className="pdfQRCodeOverlay">
                            <div className="pdfQRCodeContainer">
                                <button onClick={() => hideQRCode()}>Fermer</button>
                                <QRCode value={amn.pdfToDisplay} />
                            </div>
                        </div>
                }
        </>
      )

    /*return (
        <>
            <Document file={props.file}>
                <Page pageNumber={1} />
            </Document>
        </>
    )*/
}

export {
    PdfReader
}